import styled, { css } from 'styled-components/macro';
import { Input } from '@yme/atoms/input';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio } from '@yme/utils/constants';
export const AutocompleteRequestStyled = styled.div `
  position: relative;
`;
export const ControlPanelStyled = styled.div `
  position: absolute;
  bottom: 0;
  top: 0;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 0 10px;
  z-index: ${Z_INDEX.level1};

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0px; direction: rtl;' : 'right: 0px;')}
`;
export const InputStyled = styled(Input) `
  ${({ isInputImage, isRightToLeft }) => isInputImage &&
    css `
      input {
        padding: ${isRightToLeft ? ' 24px 108px 24px 0' : ' 24px 0 24px 108px'};

        ${ADAPTIVE.maxWidth.tablet} {
          padding: ${isRightToLeft ? ' 24px 88px 24px 0' : ' 24px 0 24px 88px'};
        }
      }

      div {
        &::before {
          width: 86px;
          height: 48px;

          ${ADAPTIVE.maxWidth.tablet} {
            width: 64px;
            height: 37px;
          }
          background-size: contain;
          background-position: center center;
          aspect-ratio: ${AspectRatio.RectangleLevel3};
        }

        ${isRightToLeft &&
        css `
          &::after {
            width: 86px;
            height: 48px;

            ${ADAPTIVE.maxWidth.tablet} {
              width: 64px;
              height: 37px;
            }
            background-size: contain;
            background-position: center center;
            aspect-ratio: ${AspectRatio.RectangleLevel3};
          }
        `}
      }
    `}
`;
